import constants from '../../constants/app-constants';

const initialState = {
  requests: null
};

const DisplayBlock = (state = initialState , action) => {
  switch(action.type){
  case constants.admin.DISPLAY_BLOCK_NEW : return {...state , requests : action.payload};

  case constants.admin.DISPLAY_BLOCK_GET: {
    return {...state, displayBlock: action.payload};
  }

  case constants.admin.DISPLAY_BLOCK_EDIT: {
    return {...state, displayBlockEdit: action.payload};
  }

  default: return state;
  }
};

export default DisplayBlock;